module.exports = __webpack_public_path__ + "img/list.993a56e0.png";